import axios from 'axios'

import { routes } from './routes.js'

const sendRequest = async (endpoint) => {
  const response = await axios.get(`${process.env.VITE_VUE_APP_API_BASE_SITEMAP_URL}${endpoint}`)
  return response.data
}

// const mapData = (data) =>
//   data.map((item) => ({
//     permalink: item.permalink,
//     images: item.images ? item.images : undefined,
//   }))

const mapData = (data) => data.map((item) => item.permalink)

export const getMixCategories = async () => {
  return mapData((await sendRequest('mix_categories')).categories)
}

export const getProductCategories = async () => {
  return mapData((await sendRequest('product_categories')).categories)
}

export const getProducts = async () => {
  return mapData((await sendRequest('products')).products)
}

export const getArticles = async () => {
  return mapData((await sendRequest('articles')).articles)
}

export const getMedia = async () => {
  return mapData((await sendRequest('media')).media)
}

export const getJobOffers = async () => {
  const data = await sendRequest('job_offers')
  console.log("JOB offers data", data)
  // return data.job_offers.map((item) => ({
  //   id: item.id,
  //   images: item.images,
  // }))
}

export const getSiteMapUrls = async () => {
  console.log('Fetching and build data for sitemap...')

  const sitemapRoutes = []

  for (const route of routes) {
    if (route?.meta?.sitemap?.ignoreRoute === true) {
      continue
    }

    if (route?.meta?.sitemap?.slugs) {
      const slugs = await route?.meta?.sitemap.slugs()
      if (route.path.endsWith(':id')) {
        sitemapRoutes.push(
          ...slugs.map((slug) => route.path.replace(':id', slug))
        )
      } else if (route.path.endsWith(':permalink')) {
        sitemapRoutes.push(
          ...slugs.map((slug) => route.path.replace(':permalink', slug))
        )
      }
    } else {
      sitemapRoutes.push(route.path)
    }
  }

  return sitemapRoutes
}

export const getCrawlBlockedUrl = () => {
  const blockedRoutes = []

  console.log('Generating blocked urls for robots.txt...')

  for (const route of routes) {
    if (
      route.path &&
      route?.meta?.blockRobots === true
    ) {
      let blockedRoute = route.path
        .replace(':search?', '')
        .replace(':id', '')
        .replace(':hash', '')
        .replace(':token', '')

      if (!blockedRoute.endsWith('/')) {
        blockedRoute = `${blockedRoute}/`
      }

      if (!blockedRoutes.includes(blockedRoute)) {
        blockedRoutes.push(blockedRoute)
      }
    }
  }

  console.log('Blocked urls:', blockedRoutes)

  return blockedRoutes
}
